import { NgClass } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-show-hide",
    styleUrls: ["./show-hide.component.scss"],
    templateUrl: "./show-hide.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class ShowHideComponent {
    @Input() textClosed: string;
    @Input() textOpen: string;
    visible = false;

    toggle() {
        this.visible = !this.visible;
    }
}
